import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-bar" }
const _hoisted_2 = { class: "grey" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "header-bar header-bar--full" }
const _hoisted_6 = { class: "grey" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "central" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "panel" }
const _hoisted_12 = { class: "fakeInput" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "sign-in-screen" }
const _hoisted_15 = { class: "grid" }
const _hoisted_16 = { class: "col sm:col-2" }
const _hoisted_17 = { class: "col sm:col-10" }
const _hoisted_18 = {
  key: 1,
  class: "track-screen"
}
const _hoisted_19 = { class: "grid" }
const _hoisted_20 = { class: "col sm:col-2" }
const _hoisted_21 = { class: "col sm:col-10" }
const _hoisted_22 = {
  key: 2,
  class: "track-screen"
}
const _hoisted_23 = { class: "grid" }
const _hoisted_24 = { class: "col sm:col-12" }
const _hoisted_25 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_selector = _resolveComponent("logo-selector")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_background_selector = _resolveComponent("background-selector")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "setup-title", {}, undefined, true),
    _cache[13] || (_cache[13] = _createElementVNode("h5", null, "Platform", -1)),
    _createVNode(_component_logo_selector, {
      title: "Company Favicon",
      imageUrl: _ctx.favicon,
      onChange: _ctx.setFavicon
    }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("h6", null, "Header bar preview", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("img", { src: _ctx.favicon }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("img", {
            class: "menu-icon",
            src: require('@/assets/img/icon-burger.svg')
          }, null, 8, _hoisted_4)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "note" }, " NOTE: Favicon logo is only displayed at all times when the menu element is collapsed. ", -1))
      ]),
      _: 1
    }, 8, ["imageUrl", "onChange"]),
    _createVNode(_component_logo_selector, {
      title: "Company Logo",
      imageUrl: _ctx.platformLogo,
      onChange: _ctx.setPlatformLogo
    }, {
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("h6", null, "Header bar preview", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("img", { src: _ctx.platformLogo }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("img", {
            class: "menu-icon",
            src: require('@/assets/img/icon-burger.svg')
          }, null, 8, _hoisted_8)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "note" }, " NOTE: Full company logo is only visible when the menu element is expanded. ", -1))
      ]),
      _: 1
    }, 8, ["imageUrl", "onChange"]),
    _createVNode(_component_CheckBox, {
      value: _ctx.useLogoAcrossPlatform,
      text: "Use Primary Logo at Login",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setModel('useLogoAcrossPlatform', $event.value)))
    }, null, 8, ["value"]),
    (!_ctx.useLogoAcrossPlatform)
      ? (_openBlock(), _createBlock(_component_logo_selector, {
          key: 0,
          title: "Login Logo",
          imageUrl: _ctx.signinLogo,
          onChange: _ctx.setSigninLogo
        }, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("h6", null, "Sign-in screen preview", -1)),
            _createElementVNode("div", {
              class: "signinLogoPreview",
              style: _normalizeStyle(_ctx.getSigninPreviewStyle)
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", { src: _ctx.signinLogo }, null, 8, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _cache[8] || (_cache[8] = _createTextVNode(" Sign into your account ", -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: require('@/assets/img/icon-mail.svg')
                    }, null, 8, _hoisted_13),
                    _cache[7] || (_cache[7] = _createTextVNode(" Email Address ", -1))
                  ])
                ])
              ])
            ], 4)
          ]),
          _: 1
        }, 8, ["imageUrl", "onChange"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _cache[10] || (_cache[10] = _createElementVNode("h5", null, "Sign in screen background", -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_background_selector, {
            type: "colour",
            colour: _ctx.backgroundColour,
            onChange: _ctx.setBackground
          }, null, 8, ["colour", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_background_selector, {
            type: "image",
            backgroundImage: _ctx.backgroundUrl,
            previewStyle: _ctx.getSigninPreviewStyle,
            onChange: _ctx.setBackground
          }, null, 8, ["backgroundImage", "previewStyle", "onChange"])
        ])
      ])
    ]),
    _createVNode(_component_CheckBox, {
      value: _ctx.model.useBackgroundOnTrack,
      text: "customise.branding.use-background-for-track",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setModel('useBackgroundOnTrack', $event.value)))
    }, null, 8, ["value"]),
    (!_ctx.model.useBackgroundOnTrack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _cache[11] || (_cache[11] = _createElementVNode("h5", null, "Track screen background", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_background_selector, {
                type: "colour",
                colour: _ctx.backgroundColourTrack,
                onChange: _ctx.setTrackBackground
              }, null, 8, ["colour", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_background_selector, {
                type: "image",
                backgroundImage: _ctx.backgroundUrlTrack,
                previewStyle: _ctx.getTrackPreviewStyle,
                onChange: _ctx.setTrackBackground
              }, null, 8, ["backgroundImage", "previewStyle", "onChange"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CheckBox, {
      value: _ctx.model.setTrackImage,
      text: "customise.branding.separate-track-background",
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setModel('setTrackImage', $event.value)))
    }, null, 8, ["value"]),
    (_ctx.model.setTrackImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _cache[12] || (_cache[12] = _createElementVNode("h5", null, "Track image", -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_background_selector, {
                type: "image",
                backgroundImage: _ctx.backgroundImageSVG,
                previewStyle: _ctx.getTrackImagePreviewStyle,
                onChange: _ctx.setTrackImage
              }, null, 8, ["backgroundImage", "previewStyle", "onChange"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_Button, {
        text: "Save Customisations",
        size: "sm",
        onClick: _ctx.handleSaveCustomisation
      }, null, 8, ["onClick"])
    ])
  ]))
}